export async function fetchVideoAddressById(id: string | number) {
  return http
    .get<Video.Address>('/v1/video/getPlayAddress', { id })
    .then((res) => res.data)
}
